module.exports = __webpack_public_path__ + "static/01BANNER-09-bd7e6f5305edcbf93bf8a1bd839b7971.png";